import { Services } from '@sigma-frontend-libs/commons'
import { DICTIONARIES } from '@sigma-legacy-libs/essentials/lib/constants'

import { buttonModes, components, icons } from '@/utils'

import button from '@/components/button'
import info from '@/components/info'

const rows = {
  [DICTIONARIES['phone:mnp']]: [ 'Number', 'OwnerId', 'MCC', 'MNC' ],
  [DICTIONARIES['phone:ranges']]: [ 'NumberFrom', 'NumberTo', 'OwnerId', 'RegionCode', 'MCC', 'MNC' ],
  [DICTIONARIES['phone:opgroups']]: [ 'GROUP', 'OrgCode', 'TYPE', 'MCC', 'MNC' ]
}

function renderTitle(h, title) {
  return h(
    'div',
    {
      class: `${Services.dictionaries}-dialog__row-title`
    },
    [ title ]
  )
}
function renderText(h, text) {
  return h(
    'div',
    {
      class: `${Services.dictionaries}-dialog__row-text`
    },
    [ this.getTranslate(`${Services.dictionaries}.info.rows.${text}`) ]
  )
}
function renderRows(h) {
  const dictionaryRows = rows[this.dictionaryType] || []

  return h(
    'div',
    {
      class: `${Services.dictionaries}-dialog__rows`
    },
    [
      dictionaryRows.map(row => {
        return h(
          'div',
          {
            class: `${Services.dictionaries}-dialog__row`
          },
          [
            renderTitle.call(this, h, row),
            renderText.call(this, h, row)
          ]
        )
      })
    ]
  )
}
function renderInfo(h) {
  return h(
    info,
    {
      props: {
        value: this.getTranslate(`${Services.dictionaries}.info.hint`)
      }
    }
  )
}
function renderBody(h) {
  return h(
    'div',
    {
      class: `${Services.dictionaries}-dialog__body`
    },
    [
      renderRows.call(this, h),
      renderInfo.call(this, h)
    ]
  )
}

function renderFooter(h) {
  return h(
    'div',
    {
      class: 'dialog__footer',
      slot: 'footer'
    },
    [
      h(
        button,
        {
          props: {
            label: this.getTranslate('misc.buttons.close'),
            mode: buttonModes.flat
          },
          on: {
            click: () => {
              this.showDialog = false
            }
          }
        }
      )
    ]
  )
}
function renderDialog(h) {
  return h(
    components.dialog,
    {
      props: {
        value: this.showDialog,
        title: this.getTranslate(`${Services.dictionaries}.titles.${this.dictionaryType}`),
        width: 500
      },
      on: {
        input: event => {
          this.showDialog = event
        }
      }
    },
    [
      renderBody.call(this, h),
      renderFooter.call(this, h)
    ]
  )
}

export default function(h) {
  return h(
    button,
    {
      props: {
        icon: icons.help_outline,
        mode: buttonModes.flat,
        tooltip: this.getTranslate(`${Services.dictionaries}.tooltips.info`)
      },
      scopedSlots: {
        dialog: () => {
          return renderDialog.call(this, h)
        }
      },
      on: {
        click: () => {
          this.showDialog = true
        }
      }
    }
  )
}
